import type { GridComponentOption } from 'echarts';

import { chartLayout } from '../config/chartLayout';

export function getTrackHeight(laneCount: number) {
  return laneCount * chartLayout.trackLaneHeight;
}

/**
 * Both grids take exactly the insets given here. ECharts 6 otherwise shrinks a grid on its own
 * (`outerBoundsMode: 'auto'`) whenever an axis label would overflow the chart. The plot's time
 * labels move with every zoom and pan step, so the plot grid would keep shifting against the track
 * grid, and the plot's lane highlight bands would slide off the track bars they belong to.
 */
const FIXED_GRID_BOUNDS = { outerBoundsMode: 'none' } as const satisfies GridComponentOption;

/** Plot grid first, track grid second. Lane labels overlay the track, so no label gutter is reserved. */
export function buildGridOption(
  laneCount: number,
  hasNavigation: boolean,
  hasRangeTrackLabel = false
): GridComponentOption[] {
  const navigationHeight = hasNavigation ? chartLayout.navigationReservedHeight : 0;
  const horizontalExtent = {
    ...FIXED_GRID_BOUNDS,
    left: chartLayout.gridSideInset,
    right: chartLayout.gridSideInset,
  };

  if (laneCount === 0) {
    return [
      {
        ...horizontalExtent,
        top: chartLayout.plotTop,
        bottom: chartLayout.timeAxisHeight + navigationHeight,
      },
    ];
  }

  const trackHeight = getTrackHeight(laneCount);
  const rangeTrackHeaderHeight = hasRangeTrackLabel ? chartLayout.rangeTrackHeaderHeight : 0;

  return [
    {
      ...horizontalExtent,
      top: chartLayout.plotTop,
      bottom:
        trackHeight + rangeTrackHeaderHeight + chartLayout.trackTopGap + chartLayout.timeAxisHeight + navigationHeight,
    },
    {
      ...horizontalExtent,
      height: trackHeight,
      bottom: navigationHeight,
    },
  ];
}
